import { type ReactNode, memo } from 'react';
import { IconUsers } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import { getInitials } from '@/utils/helpers';

import styles from './InviterCard.module.css';

const MEMBER_ICON_SIZE = 14;

interface InviterCardProps {
  inviterName: string;
  inviterRole: string;
  memberCount: number;
}

export const InviterCard = memo(function InviterCard({
  inviterName,
  inviterRole,
  memberCount,
}: InviterCardProps): ReactNode {
  const { t } = useTranslation();
  const initials = getInitials(inviterName);

  return (
    <div className={styles.wrapper}>
      <div className={styles.avatar}>{initials}</div>
      <div className={styles.info}>
        <p className={styles.name}>
          {t('invitation.invitedBy', { name: inviterName })}
        </p>
        <p className={styles.role}>{inviterRole}</p>
      </div>
      <div className={styles.memberBadge}>
        <IconUsers size={MEMBER_ICON_SIZE} />
        {t('invitation.memberCount', { count: memberCount })}
      </div>
    </div>
  );
});
